export type ReportExportTypes = "CSV" | "PDF";

export enum ReportExportEnum {
    CSV = "CSV",
     // PDF = "PDF" // To na razie nie działa
}